import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { catchError, from, Observable, switchMap, throwError } from 'rxjs';

const UNAUTHORIZED_ERROR_CODE = 401;
@Injectable()
export class DefaultOAuthInterceptor implements HttpInterceptor {
  constructor(private oAuthService: OAuthService) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.oAuthService.hasValidAccessToken()) {
      const headers = req.headers.set('Authorization', this.oAuthService.authorizationHeader());
      req = req.clone({ headers });
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === UNAUTHORIZED_ERROR_CODE) {
          return from(this.oAuthService.silentRefresh()).pipe(
            switchMap(() => {
              const headers = req.headers.set(
                'Authorization',
                this.oAuthService.authorizationHeader()
              );
              const clonedRequest = req.clone({ headers });
              return next.handle(clonedRequest);
            }),
            catchError((refreshError) => {
              console.error('Silent refresh failed:', refreshError);
              this.oAuthService.logOut();
              return throwError(() => refreshError);
            })
          );
        }
        return throwError(() => error);
      })
    );
  }
}
